// react 17.0.2

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Bootstrap CSS (utility classes are used throughout the markup).
import "bootstrap/dist/css/bootstrap.min.css";
// NOTE: Bootstrap's JS bundle (bootstrap.bundle.min, which also ships Popper.js)
// was removed from the main bundle — nothing in the app uses Bootstrap's
// JS-driven components (the Navbar menu is React state; no data-bs-* triggers
// exist anywhere). Dropping it trims the main bundle and lowers TBT/INP.

const rootEl = document.getElementById('root');

// Use hydrate when react-snap has pre-rendered the page (root already has children),
// otherwise use render for normal SPA boot.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootEl,
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootEl,
  );
}

// Report Core Web Vitals (CLS, FID, FCP, LCP, TTFB) to GA4 as field data so the
// real-world impact of these optimisations is measurable. web-vitals is loaded
// lazily (dynamic import inside reportWebVitals) so it never blocks first paint.
reportWebVitals((metric) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', metric.name, {
    event_category: 'Web Vitals',
    // CLS is unit-less; multiply so GA stores a useful integer.
    value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    metric_id: metric.id,
    metric_value: metric.value,
    metric_delta: metric.delta,
    non_interaction: true,
  });
});